import React, { ChangeEvent } from 'react'
import { Checkbox } from 'transfix-ui/components/Checkbox'
import { IconButton } from 'transfix-ui/components/IconButton'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import Box from 'transfix-ui/core/Box'
import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme/colors'
import { shadows } from 'transfix-ui/theme/shadows'
import { CheckFilledIcon, RemoveIcon } from 'transfix-icons'

const useStyles = makeStyles({
  root: {
    backgroundColor: brandColors.white,
    boxShadow: shadows[10],
    display: 'flex',
    alignItems: 'center',
    position: 'fixed',
    zIndex: 10,
    bottom: 0,
    left: 0,
    width: '100%',
    padding: '20px',
  },
})

interface ISelectedShipmentsFooterProps {
  selectedShipments: number[]
  acceptShipments: () => void
  rejectShipments: () => void
  selectAllShipments: () => void
  deselectAllShipments: () => void
  disabled: boolean
}

export const SelectedShipmentsFooter = ({
  selectedShipments = [],
  selectAllShipments,
  deselectAllShipments,
  acceptShipments,
  rejectShipments,
  disabled = false,
}: ISelectedShipmentsFooterProps) => {
  const classes = useStyles()
  const message =
    selectedShipments.length === 1 ? '1 selection' : `${selectedShipments.length} selections`
  const onCheckboxChange = ({ target: { checked } }: ChangeEvent<HTMLInputElement>) => {
    if (checked) {
      selectAllShipments()
    } else {
      deselectAllShipments()
    }
  }

  return (
    <Box className={classes.root}>
      <Box marginLeft='20px'>
        <Checkbox label='Select All' disabled={disabled} onChange={onCheckboxChange} />
      </Box>
      <Box>
        <InlineMessage type={INLINE_MESSAGE_VARIANTS.INFO} message={message} />
      </Box>
      <Box marginLeft='auto'>
        <IconButton
          Icon={RemoveIcon}
          label='Reject Shipments'
          size='large'
          onClick={rejectShipments}
          disabled={disabled}
        />
      </Box>
      <Box marginLeft='20px'>
        <IconButton
          Icon={CheckFilledIcon}
          label='Accept Shipments'
          color='primary'
          size='large'
          onClick={acceptShipments}
          disabled={disabled}
        />
      </Box>
    </Box>
  )
}
